





import { EditorContent } from '@tiptap/vue-2'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    EditorContent
  },
  props: {
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    editor: {
      type: Object,
      required: true
    }
  },
  methods: {
    focus() {
      this.editor.focus()
    }
  }
})
